var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-hcaptcha", {
    ref: "hcaptcha",
    staticClass: "d-inline-block captcha-component captcha-hcaptcha",
    attrs: {
      sitekey: _vm.sitekey,
      size: _vm.size,
      loadRecaptchaScript: true,
      reCaptchaCompat: false,
      language: _vm.language,
      rqdata: _vm.rqdata,
    },
    on: {
      verify: _vm.onVerify,
      expired: _vm.onExpired,
      rendered: _vm.onRender,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }